import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'

function Banner({ title = "Sample Text", image = require('../assets/images/bcfe4e574db5ae361e57eda04a2ee840.png') }) {
    return (
        <div className='common-banner d-grid align-content-end'>
            <img src={image} alt="" className='banner-image' />
            <Container>
                <Row>
                    <Col>
                        <h1 className='m-0 fs-md-35 fs-sm-25 text-center text-md-start text-light banner-title'>{title}</h1>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default Banner